/** @file Keeps the route store in sync with the address bar (initial load and back/forward). */
import { routeStore } from '../../stores/routeStore';
import { parseRoute } from './parseRoute';

/** The parts of `window` this module touches (a fake in tests). */
export interface HistoryWindow {
  location: { pathname: string };
  addEventListener(type: 'popstate', listener: () => void): void;
  removeEventListener(type: 'popstate', listener: () => void): void;
}

/** Reads the current path now and on every `popstate`; returns a disposer. */
export function listenHistory(win: HistoryWindow): () => void {
  const sync = (): void => {
    routeStore.setState({ route: parseRoute(win.location.pathname) });
  };
  sync();
  win.addEventListener('popstate', sync);
  return () => {
    win.removeEventListener('popstate', sync);
  };
}
